import { useEffect } from 'react';

import { useTonConnectUI } from '@tonconnect/ui-react';

// Глобальная переменная для хранения экземпляра аналитики
let analyticsInstance: any = null;

// Функция для установки экземпляра аналитики
export const setAnalyticsInstance = (analytics: any) => {
  analyticsInstance = analytics;
};

// Хук для синхронизации TON Connect с аналитикой
export const useTonConnectAnalytics = () => {
  const [tonConnectUI] = useTonConnectUI();

  useEffect(() => {
    if (!analyticsInstance || !tonConnectUI) return;

    // Подключаем TON Connect к аналитике
    analyticsInstance.attachTonConnect(tonConnectUI);

    // Очистка при размонтировании
    return () => {
      // Здесь можно добавить логику очистки если нужно
    };
  }, [tonConnectUI]);
};
